/* ברלניק - דף קטגוריה */
(function () {
  'use strict';
  var WL_KEY = 'brl_wishlist_v1';
  var WL_PAGE = '/pages/favorites';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  var toastTimer;
  function toast(html) {
    var t = $('[data-toast]');
    if (!t) return;
    t.innerHTML = html;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 3200);
  }

  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    document.body.classList.add('overflow-hidden');
    var f = d.querySelector('button, a, input, select');
    if (f) setTimeout(function () { f.focus(); }, 60);
    if (id.indexOf('wish-') === 0) renderWishlist();
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    setTimeout(function () { d.hidden = true; }, 280);
    if (lastFocus) lastFocus.focus();
  }

  function readWL() {
    try {
      var l = JSON.parse(localStorage.getItem(WL_KEY));
      return Array.isArray(l) ? l : [];
    } catch (e) { return []; }
  }
  function writeWL(list) {
    try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) {}
    syncWishUI();
    try { document.dispatchEvent(new CustomEvent('brl:wishlist-change')); } catch (e) {}
  }
  function inWL(handle) { return readWL().some(function (i) { return i.handle === handle; }); }

  function syncWishUI() {
    var list = readWL();
    $$('.brl-card').forEach(function (card) {
      var btn = card.querySelector('[data-wish-toggle]');
      if (!btn) return;
      var on = list.some(function (i) { return i.handle === card.dataset.handle; });
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-wish-count]').forEach(function (c) { c.textContent = list.length; });
    $$('.brl-wish-fab').forEach(function (f) { f.classList.toggle('is-empty', list.length === 0); });
  }

  function toggleWish(card, btn) {
    var list = readWL();
    var h = card.dataset.handle;
    if (inWL(h)) {
      list = list.filter(function (i) { return i.handle !== h; });
      writeWL(list);
      toast('הוסר מהמועדפים');
    } else {
      list.unshift({
        handle: h,
        title: card.dataset.title,
        url: card.dataset.url,
        img: card.dataset.img,
        price: card.dataset.price,
        variant: card.dataset.variant,
        multi: card.dataset.multi === 'true',
        added: Date.now()
      });
      writeWL(list.slice(0, 60));
      btn.classList.remove('pop'); void btn.offsetWidth; btn.classList.add('pop');
      toast('נשמר במועדפים <a href="' + WL_PAGE + '">לצפייה</a>');
    }
  }

  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderWishlist() {
    var list = readWL();
    $$('[data-wish-list]').forEach(function (ul) {
      ul.innerHTML = list.map(function (i) {
        var addBtn = i.multi
          ? '<button type="button" data-wl-go="' + esc(i.url) + '">בחירת אפשרות</button>'
          : '<button type="button" class="is-add" data-wl-add="' + esc(i.variant) + '">לסל</button>';
        return '<li>' +
          (i.img ? '<img src="' + esc(i.img) + '" alt="" loading="lazy">' : '<span></span>') +
          '<div><a href="' + esc(i.url) + '">' + esc(i.title) + '</a><div class="brl-wl-price">' + esc(i.price) + '</div></div>' +
          '<div class="brl-wl-actions">' + addBtn +
          '<button type="button" data-wl-remove="' + esc(i.handle) + '">הסרה</button></div>' +
          '</li>';
      }).join('');
      // קישור לדף המועדפים המלא (הוספת הכל לסל, שיתוף, הדפסה)
      var parent = ul.parentNode;
      if (parent && !parent.querySelector('.brl-wl-pagelink')) {
        var a = document.createElement('a');
        a.className = 'brl-wl-pagelink';
        a.href = WL_PAGE;
        a.textContent = 'לדף המועדפים המלא: הוספת הכל לסל ושיתוף';
        a.setAttribute('style', 'display:flex;align-items:center;justify-content:center;min-height:46px;margin:14px 0 4px;border-radius:10px;background:#0d1b3a;color:#fff;font-weight:700;text-decoration:none;font-size:15px;');
        ul.insertAdjacentElement('afterend', a);
      }
      var link = parent && parent.querySelector('.brl-wl-pagelink');
      if (link) link.hidden = list.length === 0;
    });
    $$('[data-wish-empty]').forEach(function (p) { p.hidden = list.length > 0; });
  }

  function addToCart(variantId, btn) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (drawer) body.sections = 'cart-drawer,cart-icon-bubble';
    if (btn) btn.classList.add('is-loading');

    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (btn) btn.classList.remove('is-loading');
        if (res.status && res.status !== 200) {
          toast(esc(res.description || res.message || 'לא הצלחנו להוסיף לסל'));
          return;
        }
        if (btn) {
          var label = btn.querySelector('[data-atc-label]');
          var old = label ? label.textContent : '';
          btn.classList.add('is-done');
          if (label) label.textContent = 'נוסף לסל ✓';
          setTimeout(function () {
            btn.classList.remove('is-done');
            if (label) label.textContent = old;
          }, 2000);
        }
        updateHeaderCart();
        if (drawer && res.sections) {
          drawer.classList.remove('is-empty');
          var item = res.items && res.items[0] ? res.items[0] : res;
          item.sections = res.sections;
          try { drawer.renderContents(item); } catch (e) { window.location.href = '/cart'; }
        } else {
          refreshBubble();
          toast('המוצר נוסף לסל <a href="/cart">למעבר לסל</a>');
        }
      })
      .catch(function () {
        if (btn) btn.classList.remove('is-loading');
        toast('משהו השתבש, נסו שוב');
      });
  }

  // מונה העגלה בהדר של ברלניק
  function updateHeaderCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-brl-cart-link]').forEach(function (a) {
          var b = a.querySelector('.brl-main__cart-count');
          if (!cart.item_count) { if (b) b.remove(); return; }
          if (!b) {
            b = document.createElement('span');
            b.className = 'brl-main__cart-count';
            a.appendChild(b);
          }
          b.textContent = cart.item_count;
        });
      }).catch(function () {});
  }

  function refreshBubble() {
    fetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var el = document.getElementById('cart-icon-bubble');
        if (!el || !s['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
        var inner = doc.querySelector('.shopify-section');
        if (inner) el.innerHTML = inner.innerHTML;
      }).catch(function () {});
  }

  function loadMore(btn) {
    var root = btn.closest('.brl');
    var url = btn.getAttribute('href');
    var fetchUrl = url;
    var th = window.Shopify && window.Shopify.theme;
    if (th && th.role && th.role !== 'main' && fetchUrl.indexOf('preview_theme_id') === -1) {
      fetchUrl += (fetchUrl.indexOf('?') > -1 ? '&' : '?') + 'preview_theme_id=' + th.id;
    }
    fetchUrl += (fetchUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + root.dataset.section;
    btn.classList.add('is-loading');
    btn.textContent = 'טוען...';
    fetch(fetchUrl)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = root.querySelector('[data-grid]');
        var items = $$('[data-grid] > .brl-grid__item:not(.brl-grid__item--promo)', doc);
        if (!items.length) throw new Error('empty');
        items.forEach(function (li) {
          li.classList.add('is-new');
          grid.appendChild(document.importNode(li, true));
        });
        var newMore = doc.querySelector('[data-more]');
        var oldMore = root.querySelector('[data-more]');
        if (newMore && oldMore) oldMore.innerHTML = newMore.innerHTML;
        try { history.replaceState(null, '', url); } catch (e) {}
        syncWishUI();
      })
      .catch(function () { window.location.href = url; });
  }

  function initClamp() {
    $$('[data-clamp]').forEach(function (box) {
      var text = box.querySelector('.brl-hero__desc-text');
      var btn = box.querySelector('[data-clamp-toggle]');
      if (!text || !btn) return;
      var lines = box.getAttribute('data-clamp-lines') || 3;
      box.style.setProperty('--clamp', lines);
      box.classList.add('is-clamped');
      if (text.scrollHeight > text.clientHeight + 4) {
        btn.hidden = false;
      } else {
        box.classList.remove('is-clamped');
      }
      btn.addEventListener('click', function () {
        var c = box.classList.toggle('is-clamped');
        btn.textContent = c ? 'קראו עוד' : 'הצגת פחות';
      });
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    var wishBtn = t.closest('[data-wish-toggle]');
    if (wishBtn) {
      e.preventDefault();
      toggleWish(wishBtn.closest('.brl-card'), wishBtn);
      return;
    }

    var opener = t.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }

    if (t.closest('[data-open-wish]')) {
      e.preventDefault();
      var fab = $('.brl-wish-fab');
      if (fab) openDrawer(fab.getAttribute('data-drawer-open'));
      else window.location.href = WL_PAGE;
      return;
    }

    var closer = t.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('[data-drawer]')); return; }

    var more = t.closest('[data-more-btn]');
    if (more) { e.preventDefault(); loadMore(more); return; }

    var rm = t.closest('[data-wl-remove]');
    if (rm) {
      var h = rm.getAttribute('data-wl-remove');
      writeWL(readWL().filter(function (i) { return i.handle !== h; }));
      renderWishlist();
      return;
    }
    var add = t.closest('[data-wl-add]');
    if (add) {
      var d = add.closest('[data-drawer]');
      if (d) closeDrawer(d);
      addToCart(add.getAttribute('data-wl-add'), null);
      return;
    }
    var go = t.closest('[data-wl-go]');
    if (go) { window.location.href = go.getAttribute('data-wl-go'); }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-atc-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    addToCart(id, form.querySelector('.brl-atc'));
  });

  document.addEventListener('change', function (e) {
    var sortSel = e.target.closest('[data-sort-select]');
    if (sortSel) { sortSel.form.submit(); return; }

    var vSel = e.target.closest('[data-variant-select]');
    if (vSel) {
      var card = vSel.closest('.brl-card');
      var opt = vSel.options[vSel.selectedIndex];
      var now = card.querySelector('.brl-price__now');
      var from = card.querySelector('.brl-price__from');
      if (now && opt.dataset.price) now.textContent = opt.dataset.price;
      if (from) from.hidden = true;
      card.dataset.variant = vSel.value;
    }
  });

  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape') return;
    var open = $('.brl-drawer.is-open');
    if (open) closeDrawer(open);
  });

  // שינוי ברשימה מטאב אחר (למשל הסרה בדף המועדפים)
  window.addEventListener('storage', function (e) { if (e.key === WL_KEY) syncWishUI(); });
  window.addEventListener('pageshow', syncWishUI);

  function init() {
    syncWishUI();
    initClamp();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
